import React from "react";
import { useNavigate } from "react-router-dom";

import { FaThumbsUp, FaRegThumbsUp, FaCalendarAlt } from "react-icons/fa";
import { useInView } from "react-intersection-observer";

const EchoesDTUPreview = ({ id }) => {
  const navigate = useNavigate();
  // Using react-intersection-observer for animations
  const [headingRef, headingInView] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const [columnsRef, columnsInView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  // Extended dummy data with more items for infinite scroll
  const dummyData = {
    jobsReferrals: [
      {
        id: 3,
        user_name: "Divyansh Bansal",
        email: "divyansh.bansal@alumni.dtu.ac.in",
        title: "AI Developer at Google Research",
        body: "Referrals open for Summer 2025. Strong background in Python and TensorFlow required.",
        tags: ["Jobs & Opportunities"],
        date: "2025-05-12",
        upvotes: 35,
      },
      {
        id: 1,
        user_name: "Sarthak Verma",
        email: "sarthak@alumni.dtu.ac.in",
        title: "SDE Internship at Amazon",
        body: "We're hiring interns for our Bengaluru office. Great opportunity for hands-on experience with AWS tech stack.",
        tags: ["Jobs & Opportunities"],
        date: "2025-06-10",
        upvotes: 18,
      },
      {
        id: 2,
        user_name: "Divyansh Sinha",
        email: "divyansh.sinha@alumni.dtu.ac.in",
        title: "Full-time Backend Role at Adobe",
        body: "Looking for enthusiastic backend engineers with experience in Node.js. Referral slots open till May 30.",
        tags: ["Jobs & Opportunities"],
        date: "2025-05-05",
        upvotes: 22,
      },

      {
        id: 4,
        user_name: "Mehak Jain",
        email: "mehak@alumni.dtu.ac.in",
        title: "UI/UX Role at Zomato",
        body: "We're looking for design graduates for a full-time role in our Gurgaon office.",
        tags: ["Jobs & Opportunities"],
        date: "2025-05-19",
        upvotes: 14,
      },
    ],

    generalTeamUp: [
      {
        id: 1,
        user_name: "Neha Singh",
        email: "nehasingh@dtu.ac.in",
        title: "Team up for HackDTU 2025",
        body: "Looking for 2 frontend devs and 1 designer for an EdTech idea. DM me your GitHub!",
        tags: ["Team Up"],
        date: "2025-05-15",
        upvotes: 10,
      },
      {
        id: 2,
        user_name: "Aakash Gupta",
        email: "aakash@dtu.ac.in",
        title: "Course Poll: Web Dev Elective",
        body: "Which elective should we choose for semester 6? React-based or Python-based?",
        tags: ["Polls"],
        date: "2025-05-18",
        upvotes: 7,
      },
      {
        id: 3,
        user_name: "Divya Narang",
        email: "divya@dtu.ac.in",
        title: "Looking for Android Dev for Hackathon",
        body: "We’re building a health app for the MedHack. Need 1 Android dev ASAP.",
        tags: ["Team Up"],
        date: "2025-05-20",
        upvotes: 12,
      },
      {
        id: 4,
        user_name: "Yash Malhotra",
        email: "yashm@dtu.ac.in",
        title: "General Poll: DTU Fest Theme",
        body: "What theme would you prefer for Invictus 2025? Retro, Futuristic, or Minimal?",
        tags: ["Polls"],
        date: "2025-05-09",
        upvotes: 16,
      },
      {
        id: 5,
        user_name: "Ritika Sharma",
        email: "ritika.sharma@dtu.ac.in",
        title: "Need teammate for Smart India Hackathon",
        body: "Working on a social impact idea, need someone with backend + DB skills.",
        tags: ["Team Up"],
        date: "2025-05-14",
        upvotes: 8,
      },
      {
        id: 6,
        user_name: "Kabir Arora",
        email: "kabira@dtu.ac.in",
        title: "Poll: Summer Workshop Preferences",
        body: "Would you attend a workshop on 'AI Ethics' or 'DevOps with Docker'?",
        tags: ["Polls"],
        date: "2025-05-06",
        upvotes: 9,
      },
    ],

    eventsLostFound: [
      {
        id: 1,
        user_name: "Cultural Council",
        email: "culture@dtu.ac.in",
        title: "Rhythm'25 Auditions",
        body: "Auditions for singing and dance categories begin next week. All branches welcome!",
        tags: ["Events"],
        date: "2025-05-22",
        upvotes: 30,
      },
      {
        id: 2,
        user_name: "Ananya Mehta",
        email: "ananya@dtu.ac.in",
        title: "Lost Red Notebook in Library",
        body: "Contains project notes and ID card. Please return if found. Last seen near Reading Room 2.",
        tags: ["Lost & Found"],
        date: "2025-05-17",
        upvotes: 5,
      },
      {
        id: 3,
        user_name: "Rohan Bansal",
        email: "rohanb@dtu.ac.in",
        title: "Lost: Black Puma Wallet",
        body: "Lost near the Mechanical Block canteen. Contains PAN card and DTU ID.",
        tags: ["Lost & Found"],
        date: "2025-05-11",
        upvotes: 4,
      },
      {
        id: 4,
        user_name: "Divyanshu Sinha",
        email: "divyanshu.sinha@dtu.ac.in",
        title: "Found: Apple AirPods",
        body: "Found near the Sports Complex. Contact me with the serial number to claim.",
        tags: ["Lost & Found"],
        date: "2025-05-16",
        upvotes: 6,
      },
      {
        id: 5,
        user_name: "DTU Tech Society",
        email: "techsoc@dtu.ac.in",
        title: "TechWeek'25 Schedule Released",
        body: "Full list of events, workshops, and guest lectures is now live on our portal.",
        tags: ["Events"],
        date: "2025-05-10",
        upvotes: 21,
      },
      {
        id: 6,
        user_name: "Manish Kapoor",
        email: "manish.k@dtu.ac.in",
        title: "Lost: Blue Nescafé Bottle",
        body: "Lost during lunch time near MechC. Reward if found!",
        tags: ["Lost & Found"],
        date: "2025-05-08",
        upvotes: 2,
      },
    ],
  };

  return (
    <section
      id={id}
      className="bg-white py-16 sm:py-20 px-6 sm:px-8 md:px-12 lg:px-24 xl:px-32 font-['Satoshi',sans-serif]  overflow-hidden"
    >
      <div className="max-w-[1800px] mx-auto">
        {/* Heading */}
        <div className="mb-10">
          <h2
            ref={headingRef}
            className={`text-[#800000] font-black text-6xl sm:text-7xl md:text-[6rem] leading-tight tracking-normal transition-all duration-1000 ease-in-out ${
              headingInView
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-10"
            }`}
          >
            Echoes<span>DTU</span>
          </h2>
          <div
            className={`h-1 w-20 bg-[#FFD700] mt-4 transition-all duration-1000 ${
              headingInView
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-4"
            }`}
          />
          <p
            className={`mt-6 text-[#4B5563] font-['Satoshi',sans-serif] text-lg sm:text-2xl leading-relaxed tracking-tight max-w-full lg:max-w-[70%] transition-all duration-1000 ease-in-out delay-200 ${
              headingInView
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-10"
            }`}
          >
            <span className="font-bold">INTRODUCING</span> the vibrant pulse of
            DTU's community - where ideas meet opportunities and connections are
            made.
          </p>
        </div>

        {/* Columns */}
        <div
          ref={columnsRef}
          className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 ease-in-out ${
            columnsInView ? "opacity-100" : "opacity-0"
          }`}
        >
          {/* Fast scrolling column */}
          <div className="col-span-1 relative h-[80vh] overflow-hidden">
            <div className="sticky top-0 bg-white z-3 pb-2">
              <h3 className="text-xl font-semibold text-[#800000] uppercase tracking-wider">
                Jobs & Opportunities
              </h3>
              <div className="h-1 bg-gradient-to-r from-[#800000] to-transparent mt-1"></div>
            </div>
            <div className="h-full w-full overflow-hidden">
              <div className="animate-scroll-up space-y-6">
                {[...dummyData.jobsReferrals, ...dummyData.jobsReferrals].map(
                  (post, i) => (
                    <PostCard key={`jobs-${post.id}-${i}`} post={post} />
                  )
                )}
              </div>
            </div>
            <div className="absolute inset-x-0 bottom-0 h-12 bg-gradient-to-t from-[#f8f8f8] to-transparent pointer-events-none"></div>
          </div>

          {/* Center description column */}

          {/* Center description column with reduced height */}
          <div className="col-span-1 flex flex-col items-center justify-center bg-white rounded-2xl shadow-md border border-gray-400">
            <div className="text-center space-y-3">
              <h3 className="text-2xl font-semibold text-[#800000] tracking-tight">
                DTU’s Community Hub
              </h3>
              {/* Gold line below the heading */}
              <div className="mx-auto mt-2 w-16 h-1 bg-yellow-500 rounded-full"></div>

              <p
                className={`text-[#4B5563] font-['Satoshi',sans-serif] text-sm sm:text-lg leading-relaxed tracking-tight max-w-full lg:max-w-[75%] mx-auto transition-all duration-1000 ease-in-out delay-200 ${
                  headingInView
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-10"
                }`}
              >
                EchoesDTU is where the campus heartbeat thrives. Whether you’re
                exploring job referrals, building your dream hackathon team, or
                syncing with the latest events—this is your space for
                connection, collaboration, and opportunity.
              </p>

              <button
                onClick={() => navigate("/login")}
                className="inline-flex items-center justify-center gap-2 bg-[#800000] hover:bg-[#a10000] text-white text-sm sm:text-base px-5 py-2.5 rounded-full font-medium transition-all duration-300 shadow-sm hover:shadow-md"
              >
                Join the Conversation
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </button>
            </div>
          </div>

          {/* Slow scrolling column */}
          <div className="col-span-1 relative h-[80vh] overflow-hidden">
            <div className="sticky top-0 bg-white z-3 pb-2">
              <h3 className="text-xl font-semibold text-[#800000] uppercase tracking-wider">
                Events, Team-Ups & Lost/Found
              </h3>
              <div className="h-1 bg-gradient-to-r from-[#800000] to-transparent mt-1"></div>
            </div>
            <div className="h-full w-full overflow-hidden">
              <div className="animate-scroll-up-slow space-y-6">
                {[
                  ...dummyData.eventsLostFound,
                  ...dummyData.eventsLostFound,
                ].map((post, i) => (
                  <PostCard key={`events-${post.id}-${i}`} post={post} />
                ))}
              </div>
            </div>
            <div className="absolute inset-x-0 bottom-0 h-12 bg-gradient-to-t from-[#f8f8f8] to-transparent pointer-events-none"></div>
          </div>
        </div>
        <p className="mt-5 text-md text-gray-400 text-center">
          *Content shown is for demonstration purposes only and does not reflect
          real-time data.
        </p>
      </div>

      {/* CSS for animations */}
      <style jsx>{`
        @keyframes scrollUp {
          0% {
            transform: translateY(0);
          }
          100% {
            transform: translateY(-50%);
          }
        }
        @keyframes scrollDown {
          0% {
            transform: translateY(-50%);
          }
          100% {
            transform: translateY(0);
          }
        }
        .animate-scroll-up {
          animation: scrollUp 30s linear infinite;
        }
        .animate-scroll-down {
          animation: scrollDown 30s linear infinite;
        }
        .animate-scroll-up-slow {
          animation: scrollUp 30s linear infinite;
        }
        .animate-scroll-up:hover,
        .animate-scroll-down:hover,
        .animate-scroll-up-slow:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

// Post card component (keeps original color scheme)
const PostCard = ({ post }) => {
  return (
    <div className="bg-white rounded-xl p-4 shadow-md border border-gray-100 mb-6">
      <div className="flex items-start space-x-3 mb-3">
        <div className="w-10 h-10 rounded-full bg-[#A41E22] flex items-center justify-center">
          <span className="text-white text-sm font-medium">
            {post.user_name
              .split(" ")
              .map((n) => n[0])
              .join("")}
          </span>
        </div>
        <div className="flex-1">
          <h3 className="font-medium text-[#A41E22]">{post.user_name}</h3>
          <p className="text-xs text-red-600">{post.email}</p>
        </div>
      </div>

      <div className="flex flex-wrap gap-1 my-2">
        {post.tags.map((tag) => (
          <span
            key={tag}
            className="text-xs px-2 py-0.5 rounded-full bg-gray-100 text-gray-600"
          >
            {tag}
          </span>
        ))}
      </div>

      <div className="flex items-center text-xs mb-2 text-gray-500">
        <FaCalendarAlt className="mr-1" />
        {new Date(post.date).toLocaleDateString()}
      </div>

      <h4 className="font-medium mb-1 text-gray-800">{post.title}</h4>
      <p className="text-sm text-gray-600 line-clamp-3 mb-2">{post.body}</p>

      <div className="flex items-center justify-between mt-3 pt-3 text-xs border-t border-gray-100">
        <span className="text-gray-500">
          Posted {Math.floor(Math.random() * 7) + 1} days ago
        </span>
        <div className="flex items-center space-x-1 text-gray-500">
          <FaRegThumbsUp />
          <span>{post.upvotes}</span>
        </div>
      </div>
    </div>
  );
};

export default EchoesDTUPreview;
